import React from "react";
import {NativeBottomSheet} from "~/apps/core/ui/BottomSheet/NativeBottomSheet";
import {SpringBottomSheet} from "~/apps/core/ui/BottomSheet/SpringBottomSheet";

export type BottomSheetProps = {
    title?: any
    open: boolean
    onClose: () => void
    children?: any
    variant?: "spring" | "native"
    containerClassName?: string
    isCalendar?: boolean
}

const defaultProps: Partial<BottomSheetProps> = {
    variant: "native"
}

export const BottomSheet = (props: BottomSheetProps) => {
    const {variant, ...other} = props;
    if (variant == "spring") {
        return <SpringBottomSheet {...other}/>;
    } else {
        return <NativeBottomSheet {...other}/>
    }
}
BottomSheet.defaultProps = defaultProps;
